import yup from 'core/utils/validators';
import {
  FIELD_REQUIRED,
  MESSAGE_FIRST_NUMBER_NO_VALID,
  MESSAGE_PHONE_NUMBER_LENGTH,
  getMaxLength,
  getMinLength,
  phoneRegExp,
  validPhoneCodes
} from 'const';

const { object, string } = yup;

export const AdditionalDetailsFormSchema = () => {
  return object().shape({
    contact_name: string()
      .min(2, getMinLength(2))
      .max(50, getMaxLength(50))
      .required(FIELD_REQUIRED),
    contact_phone_number: string()
      .validateCodePhone(validPhoneCodes, MESSAGE_FIRST_NUMBER_NO_VALID)
      .matches(phoneRegExp, MESSAGE_PHONE_NUMBER_LENGTH)
      .required(FIELD_REQUIRED),
    contact_relationship: string().nullable().required(FIELD_REQUIRED),
  });
};
